jQuery(function($){ 
    
    $( '.post-list-section' ).each( function() {
        
        var parent = $(this);
        
        var sectionId = $(this).data('id'),
            queryVar = $(this).data('vars'),
            filterpageVar = $(this).data('filterpage'),
            ajaxurlVar = $(this).data('ajaxurl'),
            maxpageVar = $(this).data('maxpage'),
            colorVar = $(this).data('color');
        
        
        //Load More Button Click
//        function loadMore(){
            $(this).find('.study_loadmore').on('click', function(e) {
//            parent.find('.study_loadmore').on('click', function(e) {
                e.preventDefault();

                var button = $(this),
                    data = {
                        'action': 'studyloadmore',
                        'query': queryVar,
                        'page' : filterpageVar
                    };

                $.ajax({
                    url : ajaxurlVar, // AJAX handler
                    data : data,
                    type : 'POST',
                    beforeSend : function ( ) {
                        button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                    },
                    success : function( data ){
                        if( data ) { 
                            button.find('span').text( 'See More Case Studies' ).parent().prev().after(data); // insert new posts
                            filterpageVar++;

                            if ( filterpageVar == maxpageVar )
                                button.remove(); // if last page, remove the button
                        } else {
                            button.find('span').text( 'No data' );
                        }
                    }
                });
            });	
//        }
        
//        loadMore();
        
        //Search Box Input
        $(this).find('.post-filter #study_search_btn_' + sectionId).on('click', function(e) {
            e.preventDefault();
            
            var firstClick = true,
                filterpageVar = '';
            
            //set filter ID
            var filter = $('#study_filter_' + sectionId);
            
            //show clear filter button
            filter.find('#studyclearfilter_' + sectionId).show();
            
            $.ajax({
                url:filter.attr('action'),
                data:filter.serialize(), // form data
                type:filter.attr('method'), // POST
                success:function(data){
                    $('#study_content_' + sectionId).html(data); // insert data


                    /*
                     * LOAD MORE
                     */
                    parent.find('.study_loadmore').on('click', function(e) {
                        e.preventDefault();
                        
                        
                        
                        if(firstClick == true){
                            filterpageVar = $(this).data('loadfilterpage');
                        }
                        
                        var queryVar = $(this).data('loadvars'),
                            ajaxurlVar = $(this).data('loadajaxurl'),
                            maxpageVar = $(this).data('loadmaxpage');
                        
//
                        var button = $(this),
                            data = {
                                'action': 'studyloadmore',
                                'query': queryVar,
                                'page' : filterpageVar
                            };

                        $.ajax({
                            url : ajaxurlVar, // AJAX handler
                            data : data,
                            type : 'POST',
                            beforeSend : function ( ) {
                                button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                            },
                            success : function( data ){
                                if( data ) { 

                                    
                                    button.find('span').text( 'See More Case Studies' ).parent().prev().after(data); // insert new posts
                                    
                                    filterpageVar++;
                                    
                                    firstClick = false;
                                    
                                    $(this).data('loadfilterpage', filterpageVar);
                                    

                                    if ( filterpageVar == maxpageVar )
                                        button.remove(); // if last page, remove the button
                                } else {
                                    button.find('span').text( 'No data' );
                                }
                            }
                        });
                    });	
                }
            });
            return false;
        });
        
        //Select Filter Change
        $(this).find('.post-filter select').on('change', function(e) {
            e.preventDefault();
            
            var firstClick = true,
                filterpageVar = '';
            
            //set filter ID
            var filter = $('#study_filter_' + sectionId);
            
            //show clear filter button
            filter.find('#studyclearfilter_' + sectionId).show();
            
            $.ajax({
                url:filter.attr('action'),
                data:filter.serialize(), // form data
                type:filter.attr('method'), // POST
                success:function(data){
                    $('#study_content_' + sectionId).html(data); // insert data

                    
                    
                    /*
                     * LOAD MORE
                     */
                    parent.find('.study_loadmore').on('click', function(e) {
                        e.preventDefault();
                        
                        
                        
                        if(firstClick == true){
                            filterpageVar = $(this).data('loadfilterpage');
                        }
                        
                        var queryVar = $(this).data('loadvars'),
                            ajaxurlVar = $(this).data('loadajaxurl'),
                            maxpageVar = $(this).data('loadmaxpage');
                        
//
                        var button = $(this),
                            data = {
                                'action': 'studyloadmore',
                                'query': queryVar,
                                'page' : filterpageVar
                            };

                        $.ajax({
                            url : ajaxurlVar, // AJAX handler
                            data : data,
                            type : 'POST',
                            beforeSend : function ( ) {
                                button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                            },
                            success : function( data ){
                                if( data ) { 

                                    
                                    button.find('span').text( 'See More Case Studies' ).parent().prev().after(data); // insert new posts
                                    
                                    filterpageVar++;
                                    
                                    firstClick = false;
                                    
                                    $(this).data('loadfilterpage', filterpageVar);
                                    

                                    if ( filterpageVar == maxpageVar )
                                        button.remove(); // if last page, remove the button
                                } else {
                                    button.find('span').text( 'No data' );
                                }
                            }
                        });
                    });	
                    
                }
            });
            return false;
        });
        
        //Clear Filter Toggle
        $(this).find('#studyclearfilter_' + sectionId).click(function(e){
            e.preventDefault();
            
            var firstClick = true,
                filterpageVar = '';
            
            $(this).hide();
            
            //set filter ID
            var filter = $('#study_filter_' + sectionId);
            
            //clear any selected dropdowns in form
            filter.find(':selected').prop('selected', false);
            
            //clear the input text field
            filter.find('input[type="text"]').val('');
            
            
            $.ajax({
                url:filter.attr('action'),
                data:filter.serialize(), // form data
                type:filter.attr('method'), // POST
                success:function(data){
                    $('#study_content_' + sectionId).html(data); // insert data

                    /*
                     * LOAD MORE
                     */
                    parent.find('.study_loadmore').on('click', function(e) {
                        e.preventDefault();
                        
                        
                        
                        if(firstClick == true){
                            filterpageVar = $(this).data('loadfilterpage');
                        }
                        
                        var queryVar = $(this).data('loadvars'),
                            ajaxurlVar = $(this).data('loadajaxurl'),
                            maxpageVar = $(this).data('loadmaxpage');
                        
//
                        var button = $(this),
                            data = {
                                'action': 'studyloadmore',
                                'query': queryVar,
                                'page' : filterpageVar
                            };

                        $.ajax({
                            url : ajaxurlVar, // AJAX handler
                            data : data,
                            type : 'POST',
                            beforeSend : function ( ) {
                                button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                            },
                            success : function( data ){
                                if( data ) { 

                                    
                                    button.find('span').text( 'See More Case Studies' ).parent().prev().after(data); // insert new posts
                                    
                                    filterpageVar++;
                                    
                                    firstClick = false;
                                    
                                    $(this).data('loadfilterpage', filterpageVar);
                                    

                                    if ( filterpageVar == maxpageVar )
                                        button.remove(); // if last page, remove the button
                                } else {
                                    button.find('span').text( 'No data' );
                                }
                            }
                        });
                    });	
                }
            });
            return false;
        });
        
        
        //Filter Toggle for Mobile
        $('#study_filter_toggle_' + sectionId).click(function(){
            $(this).toggleClass('active').next().slideToggle();
        });
        
    });
});